import axios from 'axios';
import {buildQuery} from 'utils/QueryUtils';

export const findWards = (headers, params) => {
  let query = buildQuery(params);
  return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/wards${query}`, {
    headers,
  });
};

export const findWardById = (headers, id) => {
  return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/wards/${id}`, {
    headers,
  });
};

export const createWard = (headers, data) => {
  return axios.post(`${process.env.REACT_APP_CATEGORY_API_URL}/wards`, data, {
    headers,
  });
};

export const updateWard = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_CATEGORY_API_URL}/wards/${id}`,
    data,
    {
      headers,
    },
  );
};

export const deleteWard = (headers, id) => {
  return axios.delete(`${process.env.REACT_APP_CATEGORY_API_URL}/wards/${id}`, {
    headers: headers,
  });
};

export const deleteWards = (headers, ids) => {
  return axios.delete(
    `${process.env.REACT_APP_CATEGORY_API_URL}/wards?id=${ids.join()}`,
    {
      headers: headers,
    },
  );
};
